import React from 'react';
import { Container, SpaceBetween } from '@amzn/awsui-components-core';
import MetadataTileInput from '../MetadataTileInput';
import NoticeOfPublication from '../../../common/NoticeOfPublication';
import constants from '../../../../common/constants';
import InfoLink from '../../../common/InfoLink';
import { ContentAudience, ContentType } from '@amzn/awscat-pattern-library-service-model';
import { ContentAudienceOptions } from '../../../utils/SelectableOptions';

interface Step1Props {
  readonly contentType: ContentType | undefined;
  readonly setContentType: (value: ContentType | undefined) => void;
  readonly contentAudience: ContentAudience | undefined;
  readonly setContentAudience: (value: ContentAudience | undefined) => void;
}

// TODO: Migrate this to SelectableOptions once the old options are deprecated
const contentTypeOptions = [
  {
    value: ContentType.Pattern,
    label: constants.CREATE_CONTENT_WIZARD_CONTENT_TYPE_PATTERN_LABEL,
    description: constants.CREATE_CONTENT_WIZARD_CONTENT_TYPE_PATTERN_DESCRIPTION,
  },
  {
    value: ContentType.Guide,
    label: constants.CREATE_CONTENT_WIZARD_CONTENT_TYPE_GUIDE_LABEL,
    description: constants.CREATE_CONTENT_WIZARD_CONTENT_TYPE_GUIDE_DESCRIPTION,
  },
];

const Step1ContentTypeAudience: React.FC<Step1Props> = ({
  contentType,
  setContentType,
  contentAudience,
  setContentAudience,
}) => {
  return (
    <Container>
      <SpaceBetween size="l">
        <MetadataTileInput
          sectionId="contentType"
          label={constants.CREATE_CONTENT_WIZARD_CONTENT_TYPE_LABEL}
          description={constants.CREATE_CONTENT_WIZARD_CONTENT_TYPE_DESCRIPTION}
          info={<InfoLink topic={`content-type`} />}
          tileOptions={contentTypeOptions}
          selectedTile={contentType ?? ''}
          isRequired={true}
          stretch={true}
          onInputUpdated={(_, value) => setContentType(value as ContentType)}
        />
        <MetadataTileInput
          sectionId="contentAudience"
          label={constants.CREATE_CONTENT_WIZARD_AUDIENCE_LABEL}
          description={constants.CREATE_CONTENT_WIZARD_AUDIENCE_DESCRIPTION}
          info={<InfoLink topic={`intended-audience`} />}
          tileOptions={ContentAudienceOptions}
          selectedTile={contentAudience ?? ''}
          isRequired={true}
          stretch={true}
          onInputUpdated={(_, value) => setContentAudience(value as ContentAudience)}
        />
        <NoticeOfPublication
          contentAudience={contentAudience}
          visible={contentAudience === ContentAudience.PUBLIC}
          alertLevel="warning"
        />
      </SpaceBetween>
    </Container>
  );
};

export default Step1ContentTypeAudience;
